import React from "react";

function HeroBg({ title }) {
  return (
    <section
      className="hero-section"
      style={{ position: "relative", height: "50vh" }}
    >
      <img
        src="images/hero-bg.png"
        alt="Vitri Enterprises Hero"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          position: "absolute",
          top: "0",
          left: "0",
          zIndex: "-1",
        }}
      />
      <div
        className="hero-text"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "white",
          textAlign: "center",
        }}
      >
        <h1>{title}</h1>
        <p>
          Your trusted partner in innovative security and office automation
          solutions.
        </p>
      </div>
    </section>
  );
}

export default HeroBg;
